import script from "./TasksTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TasksTable.vue?vue&type=script&setup=true&lang=js"

import "./TasksTable.vue?vue&type=style&index=0&id=42dc654a&lang=scss"

const __exports__ = script;

export default __exports__